import {Component, Injector, OnInit} from '@angular/core';
import {BasePageComponent} from '@twpub/shared/components/base';
import {FieldProps, ResultPage} from '@twpub/core/models';
import {ClientConfigurationScheme, ComponentConfiguration, ComponentInit, InitialConfig} from '@twpub/core/utils';
import {ComponentCategory} from '@twpub/core/enums';

import {HeaderWrapperComponent} from '../../../../shared/components/wrappers/header-wrapper/header-wrapper.component';
import {
  PreambleWrapperComponent
} from '../../../../shared/components/wrappers/preamble-wrapper/preamble-wrapper.component';
import {
  ResultViewWrapperComponent
} from '../../../../shared/components/wrappers/result-view-wrapper/result-view-wrapper.component';
import {FooterWrapperComponent} from '../../../../shared/components/wrappers/footer-wrapper/footer-wrapper.component';

@Component({
  selector: 'pub-default-result-page',
  templateUrl: './default-result-page.component.html',
  styleUrls: ['./default-result-page.component.scss'],
  standalone: true,
  imports: [HeaderWrapperComponent, PreambleWrapperComponent, ResultViewWrapperComponent, FooterWrapperComponent]
})
export class DefaultResultPageComponent extends BasePageComponent implements ResultPage, OnInit {
  constructor(private injector: Injector) {
    super(injector);
  }

  static Init = class extends ComponentInit {
    readonly scheme = ClientConfigurationScheme.DEFAULT;
    override props: FieldProps[] = [];

    constructor() {
      super(DefaultResultPageComponent, 'DefaultResultPageComponent', 'Default Result page', [ComponentCategory.ResultPage]);
    }

    createConfig(initialConfig: InitialConfig = undefined) {
      return new ComponentConfiguration<ResultPage>(DefaultResultPageComponent, this.name, initialConfig);
    }
  }
}
